import { Button, Modal, Spinner } from "react-bootstrap";

interface ModalApproverProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onReject?: () => void;
  Title: string;
  ButtonCloseLabel: string;
  ButtonConfirmLabel: string;
  ButtonRejectLabel?: string;
  showRejectButton?: boolean;
  Mensagem: string;
  isLoading: boolean; // Adiciona o estado de carregamento
}

export const ModalApprover = (props: ModalApproverProps) => {
  return (
    <>
      <Modal as={Modal.Dialog} centered show={props.isOpen} onHide={props.onClose}>
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>
          <span
            style={{
              cursor: 'pointer',
              fontSize: '1.5rem',
              lineHeight: 1,
              color: '#000', // Adjust color as needed
            }}
            onClick={props.onClose}
            aria-label='Close'
          >
            &times; {/* Close icon */}
          </span>
        </Modal.Header>
        <Modal.Body>
            <div dangerouslySetInnerHTML={{ __html: props.Mensagem }} />
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
          {props.showRejectButton && (
              <>
                {console.log("isLoading for reject button:", props.isLoading)} {/* Log do valor de isLoading */}
                <Button 
                  variant="danger" 
                  onClick={props.onReject}
                  disabled={props.isLoading} // Desabilita durante o loading
                >
                  {props.isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    {props.ButtonRejectLabel} {/* Exibe o texto de rejeição */}
                  </>
                ) : (
                  props.ButtonRejectLabel
                )}
                </Button>
              </>
            )}
            <Button 
              variant="primary" 
              onClick={props.onConfirm}
              disabled={props.isLoading} // Desabilita durante o loading
            >
              {props.isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                {props.ButtonConfirmLabel} {/* Exibe o texto do botão de carregamento */}
              </>
            ) : (
              props.ButtonConfirmLabel
            )}
            </Button>
          </div>
          <span
            style={{
              cursor: 'pointer',
              color: '#007bff', 
            }}
            onClick={props.onClose}
          >
            {props.ButtonCloseLabel}
          </span>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalApprover;
